import { useCallback, useState } from 'react';

// react-date-picker resets its boxes to the committed value whenever the calendar opens or closes.
export const useCalendarOpen = (onToggle) => {
  const [isOpen, setIsOpen] = useState(false);

  const setCalendarOpen = useCallback(
    (open) => {
      setIsOpen(open);
      onToggle?.();
    },
    [onToggle]
  );

  return [isOpen, setCalendarOpen];
};
